import { render, staticRenderFns } from "./iconWarning.vue?vue&type=template&id=6760a07c&scoped=true&"
import script from "./iconWarning.vue?vue&type=script&lang=js&"
export * from "./iconWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760a07c",
  null
  
)

export default component.exports